import API from '../config/config-api';

export const getResultBySerialAndDate = ({ serial, createdDate, customer }) => {
  return API().get(`coordinateResult?serial=${serial}&createdDate=${createdDate}&customer=${customer}`)
    .then(response => response.data)
    .catch(err => { throw err; });
};


// WEBPACK FOOTER //
// ./src/api/results-service.js